import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }

import {finishTask} from "@/api/home";
import {searchInstance} from "@/api/order";
import { reportedTypeColumns,orderTypeColumns } from "@/components/model/data";
import {message} from "ant-design-vue";
import {onMounted, reactive} from "vue";
import {useRoute, useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 't101',
  setup(__props) {

const columns = [
  {
      title: "订单类型",
      dataIndex: "typeStr",
      key: "typeStr",
  },
  {
    title: "姓名",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "电话",
    dataIndex: "mobile",
    key: "mobile",
  },
  {
    title: "拍照状态",
    dataIndex: "completed",
    key: "completed",
  },
  {
    title: "报告状态",
    dataIndex: "reported",
    key: "reported",
    customRender: ({ record }: any) => reportedTypeColumns[record.reported]
  },
  {
    title: "类型",
    dataIndex: "type",
    key: "type",
    customRender: ({ record }: any) => orderTypeColumns[record.type - 1]
  },
  {
    title: "操作",
    dataIndex: "operation",
    key: "operation",
  },
];

const data = reactive({
  dataSource: [],
  loading: false,
  pagination: {
    size: "small",
    current: 1,
    pageSize: 10,
    total: 0,
    pageSizeOptions: ["10", "20", "30"],
    showTotal: (total: string) => {
      return " 共" + total + "条";
    },
    hideOnSinglePage: false,
    showSizeChanger: true,
    soldOut: null
  },
  visible: false,
  doctorName: "",
  doctorId: 0,
  oralDetectionOrderId: 0,
  confirmLoading: false,
});
const route = useRoute();
const router = useRouter();


onMounted(() => {
  search();
});

const search = () => {
  let option: any = {
    completed: true,
    page: {
      currPage: data.pagination.current,
      pageSize: data.pagination.pageSize,
    },
    type: route.query.type,
    includeCancel: false,
    reported: 1,
    relatedId:route.query.patientId,
  };

  // if(route.query.type != '5'){
  //   option["reported"] = 0
  // }

  if (route.query.soldOut) {
    option["soldOut"] = +route.query.soldOut;
  }

  console.log(option)

  searchInstance(option).then((res: any) => {
    console.log(res);
    data.dataSource = [];
    if (null !== res) {
      data.dataSource = res.data;
      data.pagination.total = res.records;
    }
  });
};

const changePageIndex = (page: any) => {
  data.pagination.pageSize = page.pageSize;
  data.pagination.current = page.current;
  search();
};


const finishTask101 = (record : any) => {
  data.confirmLoading = true;
  console.log("提交", route.query);
  let option = {
    processDefinitionId: route.query.processDefinitionId,
    processDefinitionKey: route.query.processDefinitionKey,
    processInstanceId: route.query.processInstanceId,
    runTimeTaskId: route.query.runTimeTaskId,
    taskCode: route.query.taskCode,
    params: {
      oralDetectionOrderId: record.id
    },
  };

  finishTask(option).then(() => {
    message.success("操作成功");
    data.confirmLoading = false;
    router.push({
      path: "/home",
    });
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_table, {
      dataSource: data.dataSource,
      columns: columns,
      loading: data.confirmLoading,
      pagination: data.pagination,
      onChange: changePageIndex
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'completed')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(record.completed ? "已提交" : "未提交"), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'operation')
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              type: "link",
              onClick: ($event: any) => (finishTask101(record))
            }, {
              default: _withCtx(() => [
                _createTextVNode("选择")
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "loading", "pagination"])
  ]))
}
}

})